import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import * as fromSearch from '@app/store/actions/search.action';
import * as fromRouter from '@app/store/actions/router.action';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vc-searchbar-modal',
  templateUrl: './searchbar-modal.component.html',
  styleUrls: ['./searchbar-modal.component.scss']
})
export class SearchbarModalComponent implements OnInit {
  @Output()
  inputValue: EventEmitter<string> = new EventEmitter<string>();
  public searchValue: any;
  public recentSearches = [];
  private lastRoute: string;
  constructor(private state: Store<IAppState>, private matDialogRef: MatDialogRef<SearchbarModalComponent>) {}

  ngOnInit() {
    this.state.select('search').subscribe(
      resp => {
        this.recentSearches = resp.lastSearches;
      },
      () => {
        /* Silently catch exception */
      }
    );
    this.state.select('router').subscribe(
      resp => {
        this.lastRoute = resp.state.url;
      },
      () => {
        /* Silently catch exception */
      }
    );
  }

  leaveSearch() {
    if (this.lastRoute.indexOf('search') >= 0) {
      this.state.dispatch({ type: fromRouter.BACK });
    }
    this.state.dispatch({
      type: fromSearch.SET_IS_SEARCH_IN_PROGRESS,
      payload: false
    });
    this.state.dispatch(new fromSearch.SetSearchValue(''));
    this.closeDialog();
  }

  closeDialog() {
    this.matDialogRef.close();
  }
}
